import { Outlet, NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, MessageSquare, Users, Package, User } from "lucide-react";
import SupportWidget from "@/components/SupportWidget";
import LiveToaster from "@/components/LiveToaster";
import { useAuth } from "@/context/AuthContext";
import useLiveUpdates from "@/hooks/useLiveUpdates";

// PRIMARY nav — exactly the 5 tabs from the mobile app, in this order.
// Everything else (Docs, Loans, Reminders, Wallet, etc.) lives inside the
// Profile screen as a "More" menu.
const PRIMARY_TABS = [
  { to: "/app/dashboard", icon: LayoutDashboard, label: "Home", testid: "tab-dashboard" },
  { to: "/app/chat", icon: MessageSquare, label: "Chat", testid: "tab-chat" },
  { to: "/app/debtors", icon: Users, label: "Debtors", testid: "tab-debtors" },
  { to: "/app/inventory", icon: Package, label: "Stock", testid: "tab-inventory" },
  { to: "/app/profile", icon: User, label: "Profile", testid: "tab-profile" },
];

export default function AppShell() {
  const location = useLocation();
  const { user } = useAuth();
  useLiveUpdates(!!user);

  return (
    <div className="min-h-[100dvh] bg-kudi-cream sm:py-4">
      <div className="max-w-md mx-auto h-[100dvh] sm:h-[calc(100dvh-2rem)] bg-white sm:rounded-[2rem] phone-frame overflow-hidden flex flex-col border border-border relative">
        <div className="flex-1 overflow-y-auto no-scrollbar">
          <Outlet />
        </div>
        <nav className="border-t border-border/60 bg-white/95 backdrop-blur-xl pb-safe" data-testid="bottom-nav">
          <div className="grid grid-cols-5">
            {PRIMARY_TABS.map((t) => {
              const active = location.pathname.startsWith(t.to);
              return (
                <NavLink
                  key={t.to}
                  to={t.to}
                  className="flex flex-col items-center gap-1 py-3 px-1 transition-colors"
                  data-testid={t.testid}
                >
                  <div className={`p-2 rounded-xl transition-colors ${active ? "bg-kudi-green/10 text-kudi-green" : "text-kudi-ink/50"}`}>
                    <t.icon className="w-6 h-6" strokeWidth={active ? 2.4 : 1.8} />
                  </div>
                  <span className={`text-[11px] font-semibold ${active ? "text-kudi-green" : "text-kudi-ink/55"}`}>{t.label}</span>
                </NavLink>
              );
            })}
          </div>
        </nav>
      </div>
      <SupportWidget prefillEmail={user?.email || ""} />
      <LiveToaster />
    </div>
  );
}
